import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

/** Subdomain and custom domain mapping — mirrors stacks-agents `src/app/api/domains/`. */
@Injectable({ providedIn: 'root' })
export class DomainsApiService {
  constructor(private http: HttpClient) {}

  /** Builder JWT for the stacks-agents API */
  private agentsAuthHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` })
  }

  getDomainMappingBySubdomain(subdomain: string): Promise<{ project_id: any } | null> {
    return this.http
      .get<{ data?: { project_id: any } }>(`${environment.agentsUrl}v4/retrieval/domain-mapping/by-subdomain`, {
        headers: this.agentsAuthHeaders(),
        params: { subdomain },
      })
      .pipe(
        map(body => body?.data ?? null),
        catchError(() => of(null)),
      )
      .toPromise() as Promise<{ project_id: any } | null>
  }

  /** Upserts subdomain and/or custom domain values for a project. */
  async upsertDomainMapping(projectId: string, fields: { subdomain?: string; custom_domain?: string }): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/creation/domain-mapping`, { projectId, fields }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
  }

  /**
   * Moves a project's AI-designed site to the folder its current domain resolves to.
   * Errors propagate so the caller can decide how to report them.
   */
  async resyncVibeSite(projectId: string, from?: string): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/vibe/resync-domain`, { projectId, from }, {
        headers: this.agentsAuthHeaders(),
      })
      .toPromise()
  }
}
